import { IReports, IReportsResponse } from 'Module/Reports/Interface';
import Api from 'Shared/Services/Api/index';
import GetSystemAuthUtil from 'Shared/Utils/ConfigEnvironment/GetSystemAuth/index';


export const setReportBlockService = async (array: [IReports?]) => {
  return new Promise<IReportsResponse>(async (resolve, reject) => {
    let regReturn: IReportsResponse = {
      status: '200',
      message: '',
    };

    try {
      const _url = '/relatorioblock';

      await Api.post(_url,
        {
          "systemauth": GetSystemAuthUtil(process.env.REACT_APP_ENVIRONMENT),
          "registers": array
        })
        .then(resp => {
          resolve(regReturn);
        })
        .catch(error => {
          console.log(error);
          let msgerror = error.stack ? error.stack : 'Ocorreu um erro!';
          if (error.response && error.response.data) {
            msgerror = error.response.data.msgErr;
          }
          if (error.response && error.response.result) {
            msgerror = error.response.result.msgErr;
          }

          regReturn.status = '400';
          regReturn.message = JSON.stringify(msgerror);
          regReturn.msgErro = JSON.stringify(error);
          reject(regReturn)
        });
    }
    catch (err) {
      console.log('Reports.Service.SaveBlock.err');
      console.log(err);

      let _msgError = 'Ocorreu um erro!';
      regReturn.status = '400';
      regReturn.message = _msgError;
      regReturn.msgErro = JSON.stringify(err);
      reject(regReturn)
    }
  });
}